import { useMyStars } from "@/src/hooks/features/rewardly/use-my-stars";
import { useTranslation } from "react-i18next";
import { Text, View } from "react-native";
import StateDisplay from "../../ui-kit/state-display";
import RecentActivity from "./recent-activity";
import RecognizeUser from "./recognize-user";
import SeasonBalance from "./season-balance";

const MyStars = () => {
	const { t } = useTranslation();
	const myStars = useMyStars();

	if (!myStars.isLoading && !myStars.currentSeason) {
		return (
			<View className="flex-1 items-center justify-center">
				<StateDisplay
					descriptionLabel="LABEL_NO_ACTIVE_SEASON"
					imgSource={require("@/src/assets/images/empty.png")}
				/>
				<Text className="text-sm text-ash-2 text-center -mt-2 px-4">
					{t("LABEL_NO_SEASON_CONFIGURE_HINT")}
				</Text>
			</View>
		);
	}

	return (
		<View className="flex-1 gap-4">
			<SeasonBalance
				seasonAllowance={myStars.seasonAllowance}
				starsReceived={myStars.starsReceived}
				rewardValue={myStars.rewardValue}
				isLoading={myStars.isLoading}
			/>
			{/* Mobile: stacked, each panel sized to its own content (flex-1 here
			    would split the height and let the taller form overflow onto the
			    panel below). Web: equal side-by-side columns. */}
			<View className="flex-col gap-4 md:flex-1 md:flex-row">
				<View className="md:flex-1">
					<RecognizeUser />
				</View>
				<View className="md:flex-1">
					<RecentActivity />
				</View>
			</View>
		</View>
	);
};

export default MyStars;
